import React, { FC } from 'react';

import styles from './UserCard.module.scss';
import clsx from 'clsx';
import UserAvatar from 'components/UserAvatar';

export interface UserCardAttrs {
  firstName: string;
  lastName: string;
  imageId?: string;
}

interface UserCardTypes extends UserCardAttrs {
  onLogOutClick?: () => void;
  noMargin?: boolean;
  className?: string;
}

const UserCard: FC<UserCardTypes> = ({ firstName, lastName, imageId, noMargin = false, className, onLogOutClick }) => {
  return (
    <div className={clsx(styles.userCardContainer, noMargin && styles.noMargin, className)}>
      <div className={styles.imgContainer}>
        <UserAvatar size="medium" firstName={firstName} lastName={lastName} imageId={imageId} />
      </div>
      <div className={styles.userInfo}>
        <p className={styles.userName}>{`${firstName} ${lastName}`}</p>
        <button type="button" className={styles.link} onClick={onLogOutClick}>
          <p className={styles.linkText}>Log Out</p>
        </button>
      </div>
    </div>
  );
};

export default UserCard;
